import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorAction, csColorFunctional } from '@cloudsuite/mosaic-shared/styles/colors.style.js'

export const cscLogin = {
  loginGap: csSpacing.spacing06,
  loginTextAlign: css`var(--csc-login-text-align, start)`,
}

export const style: CSSResult = css`
  :host {
    display: contents;
    background: transparent;
    --cse-text-text-align: center;
  }

  .login-step-container {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing08};
    --cse-text-text-align: ${cscLogin.loginTextAlign};
  }
  .login-step-text-container{
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
  }
.login-step-form-container{
  display: flex;
  flex-direction: column;
  gap: ${cscLogin.loginGap};
}
  .verify-container {
    display: flex;
    flex-direction: column;
    gap:  ${csSpacing.spacing08};
    align-items: center;
  }
  .verify-step-text-container {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
  }
  .code-input {
    flex-direction: row;
    justify-content: center;
    gap: ${csSpacing.spacing06};
  }

  

  .code-input cse-text-input {
    text-align: center;
  }

  .code-input {
    display: flex;
    flex-direction: row;
    gap: ${csSpacing.spacing05};
    align-items: center;
  }

  cse-link {
    align-items: center;
  }

  .csc-login__forgot {
    display: flex;
    justify-content: center;
  }

  .csc-login__resend-wrap {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${csSpacing.spacing02};
    width: 100%;
  }

  .csc-login__resend-success {
    --cse-text-color: ${csColorFunctional.success};
    --cse-icon-width: auto;
    --cse-text-prefix-align-self: flex-start;
  }

  cse-button {
    width: 100%;
  }
  .csc-login__verify-error {
    --cse-text-color: ${csColorFunctional.error};
  }
  cse-fieldset.verify-step-form-container{
    --cse-fieldset-align-items: center;
  }
  .csc-login__back {
    --cse-link-secondary-color: ${csColorAction.linkSecondary};
    --cse-link-secondary-color-hover: ${csColorAction.linkSecondaryHover};
  }
`
